export default __webpack_public_path__ + "static/media/bubbleTop.bf983bef.svg";